angular.module('wbDashboard')
.controller('MilestoneModCashController', ['$scope',
function ($scope) {
    //simple pages: ['purpose', 'purpose-detail', 'name', 'amount', 'date']

    angular.copy(['purpose', 'purpose-detail', 'cash-name', 'amount', 'date',
        // 'initial-deposit', 'auto-deposit'
    ], $scope.pages);

    if ($scope.mod.action === "create" || !['simple', 'auto-deposit', 'allocation-start', 'confirm'].includes($scope.$stateParams.page)) {
        $scope.goToPage($scope.pages[0]);
    }

    $scope.purposes = [
        "A purchase",
        "A trip or special occasion",
        "Personal savings",
        "Paying bills or debt",
        "Other"
    ];

    $scope.purposeDescriptions = [
        "Bills",
        "Student debt",
        "Credit card debt",
        "Car loan",
        "Other"
    ];

    $scope.mod.extra.getNextPage = function() {
        var page = null;
        var pageIndex = $scope.pages.indexOf($scope.$stateParams.page);

        switch ($scope.$stateParams.page) {
            case 'purpose':
                if ($scope.milestone.metadata.purpose === "Paying bills or debt") {
                    page = "purpose-detail";
                } else {
                    delete $scope.milestone.metadata.purpose_description;
                    page = "cash-name";
                }
                break;
        }
        return page;
    };


}]);
